import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { Batch } from '../../models/batchDataModel';
import { UpdateBatchModel } from '../../models/UpdateBatchModel';
import { BatchService } from '../../services/batch/batch.service';
import { FileService } from '../../services/file/file.service';
import { UserService } from '../../services/user/user.service';
import { DisplayPageSize } from '../../Xrefs/xref-display/xrefDisplayColumns';
import {
  IChipEntry,
  IDropDownListEntry,
} from '../page-components/mdm-input/mdm-input-settings';

@Component({
  selector: 'app-batch',
  templateUrl: './batch.component.html',
  styleUrls: ['./batch.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BatchComponent implements OnInit {
  Loading: Boolean;
  Error: Boolean;
  NoData: Boolean;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  BatchData: Batch[];
  DisplayedBatchData: MatTableDataSource<Batch>;
  displayableColumns: DisplayableColumns;
  displayedColumns = [];
  displayPageSize: DisplayPageSize;
  IsAdmin: boolean = false;
  EmailAddress: string = '';
  UserName: string = '';
  user: UserService;
  selectedStatuses: IChipEntry[] = [{ key: 'all', value: 'All' }];
  ssSelectedStatus: string = 'both';
  shownStatus: ShowStatus = ShowStatus.BOTH;
  statusDropDownEntries: IDropDownListEntry[] = [
    this.getDropDownListEntry('both', 'All'),
    this.getDropDownListEntry('complete', 'Complete'),
    this.getDropDownListEntry('incomplete', 'Incomplete'),
  ];

  batchPageSize: number = 25;

  constructor(
    private _user: UserService,
    private batchService: BatchService,
    private fileService: FileService,
    public dialog: MatDialog,
  ) {
    this.user = _user;
    this.user.isAdmin.subscribe(v => {
      this.IsAdmin = v;
    });
    this.user.emailAddress.subscribe(v => {
      this.EmailAddress = v;
    });
    this.user.userName.subscribe(v => {
      this.UserName = v;
    });
  }

  ngOnInit() {
    this.displayPageSize = new DisplayPageSize();
    this.batchPageSize =
      this.displayPageSize.loadPageSize() > 0
        ? this.displayPageSize.loadPageSize()
        : 25;
    this.displayableColumns = new DisplayableColumns(this.user);
    this.displayableColumns.loadDisplayableColumns();
    this.displayedColumns = this.displayableColumns.columnDisplayArray();

    this.DisplayedBatchData = new MatTableDataSource();
    this.DisplayedBatchData.paginator = this.paginator;
    this.DisplayedBatchData.sortingDataAccessor = (item, property) => {
      try {
        if (property === 'submitted_Date') {
          const str: string = item[property].toString();
          const [month, day, year] = str.split('/');
          return new Date(+year, +month - 1, +day);
        } else if (property === 'status') {
          return item['inReviewCount'] > 0 ? 1 : 0;
        } else {
          return item[property].toLowerCase();
        }
      } catch (e) {
        return item[property];
      }
    };
    this.DisplayedBatchData.sort = this.sort;
    this.Loading = true;
    this.Error = false;
    this.NoData = false;

    this.batchService
      .GetOpenBatches()
      .then(response => {
        this.BatchData = response;
        this.selectDisplayedBatches();
        this.Loading = false;
        this.Error = false;
      })
      .catch(error => {
        this.Loading = false;
        this.Error = true;
      });
  }

  getDropDownListEntry(key: string, value: string): IDropDownListEntry {
    return {
      key: key,
      value: value,
      isDisabled: false,
      isSelected: false,
    };
  }

  selectDisplayedBatches() {
    switch (this.ssSelectedStatus) {
      case 'both':
        this.shownStatus = ShowStatus.BOTH;
        break;
      case 'complete':
        this.shownStatus = ShowStatus.COMPLETE;
        break;
      case 'incomplete':
        this.shownStatus = ShowStatus.INCOMPLETE;
        break;
      default:
        this.shownStatus = ShowStatus.BOTH;
        break;
    }
    let dispData: Batch[] = [];

    if (this.shownStatus == ShowStatus.COMPLETE) {
      this.BatchData.forEach(b => {
        if (b.inReviewCount == 0) dispData.push(b);
      });
    } else if (this.shownStatus == ShowStatus.INCOMPLETE) {
      this.BatchData.forEach(b => {
        if (b.inReviewCount > 0) dispData.push(b);
      });
    } else {
      dispData = this.BatchData;
    }
    this.DisplayedBatchData.data = dispData;
  }

  changePageSize(pageSize: number) {
    this.displayPageSize.savePage(pageSize);
  }

  markBatch(id: number) {
    let data: UpdateBatchModel = {
      BatchId: id,
    };
    this.batchService.MarkBatchAsNotNew(data);
  }

  showColumnDialog(): void {
    const dialogRef = this.dialog.open(BatchColumnDialogComponent, {
      width: '325px',
      data: this.displayableColumns.columnsAsArray(),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.displayableColumns.saveDisplayableColumns();
        this.displayedColumns = this.displayableColumns.columnDisplayArray();
      } else {
        this.displayableColumns.loadDisplayableColumns();
      }
    });
  }
  public getHeaderName(key: string) {
    try {
      return this.displayableColumns.columns[key].userReadableName;
    } catch (e) {
      return 'Unknown Column';
    }
  }

  //#region Page Functions
  ApplyFilter(filterValue: string) {
    this.DisplayedBatchData.filter = filterValue.trim().toLowerCase();
    if (this.DisplayedBatchData.paginator) {
      this.DisplayedBatchData.paginator.firstPage();
    }
  }

  ExportData() {
    let admin = this.IsAdmin;
    let outputData = this.DisplayedBatchData.data.map(function (line) {
      if (admin) {
        return {
          'Batch ID': line.batchID,
          'File Name': line.fileName,
          'Submitted Date': line.submitted_Date,
          'Uploaded By': line.userEmail,
          'Total Records': line.totalSubmissionCount,
          'Success Count': line.successCount,
          'Failure Count': line.failureCount,
        };
      } else {
        return {
          'Batch ID': line.batchID,
          'File Name': line.fileName,
          'Submitted Date': line.submitted_Date,
        };
      }
    });

    this.fileService.exportToCsv('BatchsExport.csv', outputData);
  }
  //#endregion
}

@Component({
  selector: 'app-batch-column-dialog',
  templateUrl: 'batchColumnsDialog.html',
  standalone: false,
})
export class BatchColumnDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<BatchColumnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: columnInfo[],
  ) {}

  canSelectAll(): boolean {
    return this.data.some(e => !e.visible);
  }

  selectAll(): void {
    if (this.data.some(e => !e.visible)) {
      this.data.forEach(d => {
        d.visible = true;
      });
    } else {
      this.data.forEach(d => {
        if (d.canBeRemoved) d.visible = false;
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

class columnInfo {
  public columnName: string;
  public userReadableName: string;
  public visible: boolean;
  public canBeRemoved: boolean;
}
class columnData {
  public status: columnInfo;
  public batchId: columnInfo;
  public fileName: columnInfo;
  public submittedDate: columnInfo;
  public UploadedBy: columnInfo;
  public TotalSubmissionCount: columnInfo;
  public SuccessCount: columnInfo;
  public FailureCount: columnInfo;
}
class DisplayableColumns {
  public columns: columnData;
  IsAdmin: boolean = false;
  user: UserService;
  public constructor(_user: UserService) {
    this.user = _user;
    this.user.isAdmin.subscribe(v => {
      this.IsAdmin = v;
    });

    this.columns = new columnData();
    this.columns.status = {
      canBeRemoved: false,
      visible: true,
      columnName: 'status',
      userReadableName: 'Status',
    };
    this.columns.batchId = {
      canBeRemoved: false,
      visible: true,
      columnName: 'batchID',
      userReadableName: 'Batch ID',
    };
    this.columns.fileName = {
      canBeRemoved: true,
      columnName: 'fileName',
      userReadableName: 'File Name',
      visible: true,
    };
    this.columns.submittedDate = {
      canBeRemoved: true,
      columnName: 'submitted_Date',
      userReadableName: 'Submitted Date',
      visible: true,
    };
    this.columns.UploadedBy = {
      canBeRemoved: true,
      columnName: 'userEmail',
      userReadableName: 'Uploaded By',
      visible: true,
    };
    this.columns.TotalSubmissionCount = {
      canBeRemoved: true,
      columnName: 'totalSubmissionCount',
      userReadableName: 'Total Records',
      visible: true,
    };
    this.columns.SuccessCount = {
      canBeRemoved: true,
      columnName: 'successCount',
      userReadableName: 'Success Count',
      visible: true,
    };
    this.columns.FailureCount = {
      canBeRemoved: true,
      columnName: 'failureCount',
      userReadableName: 'Failure Count',
      visible: true,
    };
  }
  public columnsAsArray(): columnInfo[] {
    const result = [];
    result.push(this.columns.status);
    result.push(this.columns.batchId);
    result.push(this.columns.fileName);
    result.push(this.columns.submittedDate);
    if (this.IsAdmin) {
      result.push(this.columns.UploadedBy);
      result.push(this.columns.TotalSubmissionCount);
      result.push(this.columns.SuccessCount);
      result.push(this.columns.FailureCount);
    }
    return result;
  }

  public loadDisplayableColumns() {
    try {
      let s = JSON.parse(localStorage.getItem('HiddenColumnsBatchPage'));
      this.columns.status.visible = s.status.visible;
      this.columns.batchId.visible = s.batchId.visible;
      this.columns.fileName.visible = s.fileName.visible;
      this.columns.submittedDate.visible = s.submittedDate.visible;
    } catch (Exception) {
      this.columns.status.visible = true;
      this.columns.batchId.visible = true;
      this.columns.fileName.visible = true;
      this.columns.submittedDate.visible = true;
    }
  }
  public saveDisplayableColumns() {
    localStorage.setItem(
      'HiddenColumnsBatchPage',
      JSON.stringify(this.columns),
    );
  }
  public columnDisplayArray(): string[] {
    const result = [];
    let cols = this.columnsAsArray();
    cols.forEach(c => {
      if (c.visible) result.push(c.columnName);
    });
    return result;
  }
}

export enum ShowStatus {
  COMPLETE,
  INCOMPLETE,
  BOTH,
}
